// bulkUploadSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
};

const bulkUploadSlice = createSlice({
  name: "bulkUploadData", 
  initialState,
  reducers: {
    addBulkAgreementAction: (state, action) => {
      state.data = action.payload; 
    },

    editBulkAgreementAction: (state, action) => {
      const { id, key, value } = action.payload;
      const objectToEdit = state.data.find((item) => item.uid === id);
      if (objectToEdit) {
        objectToEdit[key] = value; 
      }
    },

    deleteBulkAgreementAction: (state, action) => {
      state.data = state.data.filter((item) => item.uid !== action.payload); 
    },
  },
});

export const { addBulkAgreementAction, editBulkAgreementAction, deleteBulkAgreementAction } = bulkUploadSlice.actions;
export default bulkUploadSlice.reducer;
